import { Typography, Box } from "@mui/material";
import { useNotify, useRefresh, Button } from "react-admin";

import { candidateRequests } from "api/candidateApi";

import ConfirmModal from "server/components/Modals/ConfirmModal";
import DeleteIcon from "@mui/icons-material/Delete";
import ReportIcon from "@mui/icons-material/Report";
import dataProvider from "server/dataProvider";

const DeleteSpecialityModal = ({ speciality, record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleRemoveSpeciality = async (specialityId, candidacyId) => {
    await dataProvider.customRequest(candidateRequests.candidacySpeciality(candidacyId, specialityId), null, "DELETE");
    notify("Успешно изтрита специалност", { type: "success" });
    refresh();
  };
  return (
    <ConfirmModal
      triggerButton={
        <Button
          disabled={record?.hasApprovedRanking}
          startIcon={<DeleteIcon />}
          variant="contained"
          label="Изтрий"
        />
      }
      titleContent="Изтриване на специалност"
      closeTitle="Затвори"
      onConfirm={() => handleRemoveSpeciality(speciality.specialityId, record.id)}
    >
      <Box sx={{ margin: "auto" }}>
        <Box sx={{ display: "flex", gap: 1, width: "fit-content", margin: "2rem auto" }}>
          <ReportIcon
            color="error"
            fontSize="large"
            textAlign="center"
          />
          <Typography
            fontSize={14}
            sx={{ margin: "auto", display: "inline" }}
            variant="body1"
            color={"error"}
          >
            Сигурни ли сте , че искате да изтриете тази специалност?
          </Typography>
        </Box>
      </Box>
    </ConfirmModal>
  );
};
export default DeleteSpecialityModal;
